"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const delay_1 = require("../utils/delay");
class FunctionRetryStrategy {
    constructor(retryFunction) {
        this.retryFunction = retryFunction;
    }
    create() {
        let retryCount = 0;
        const self = this;
        return {
            next: async () => {
                retryCount++;
                const delayMs = self.retryFunction(retryCount);
                await delay_1.delay(delayMs);
                return { retryCount };
            }
        };
    }
}
exports.FunctionRetryStrategy = FunctionRetryStrategy;
//# sourceMappingURL=retry-strategy.js.map